angular.module('unergie.main')
.directive('asyncpopup', ($sce, $timeout, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/asyncpopup/asyncpopup.html',
        transclude: true,
        scope: {
            async: '&',
            filter: '=',
            default: '=',
            placement: '=',
            pClass: '=',
            type: '=',
        },
        link($scope) {
            $scope.data = undefined
            const watch = _.once(() =>
                $scope.$watch('opened', () => {
                    if ($scope.opened) {
                        $scope.spinning = true
                        const asynced = $scope.async()

                        return (asynced.$promise || asynced).then((data) => {
                            $timeout(() => {
                                if (!$scope.filter) {
                                    $scope.data = data.toJSON ? data.toJSON() : data
                                } else {
                                    if (!angular.isArray(data)) {
                                        data = [data]
                                    }
                                    if ((data.length === 0) || (data[0] === undefined)) {
                                        $scope.data = [$sce.trustAsHtml($scope.default)]
                                    } else {
                                        $scope.data = _.map(_.map(data, $scope.filter), $sce.trustAsHtml)
                                    }
                                }
                            })
                        }).catch((error) => {
                            $scope.data = [`ERREUR : ${error.data.message}`]
                            ErrorCatcher(error)
                        }).finally(() => {
                            $scope.spinning = false
                        })
                    }
                }))

            watch()

            $scope.close = () => {
                $scope.opened = false
            }
        },
    })
)
